/**
 * Get pagination total count from response headers
 * @param {Headers} headers - Response headers object
 * @returns {number} Total count from pagination header
 */
export const getPaginationTotalCount = (headers) => {
  if (!headers) {
    return 0;
  }
  
  // Check multiple possible header names
  const possibleHeaders = [
    'x-pagination-total-count',
    'x-total-count',
    'total-count',
    'x-pagination-page-count',
    'x-page-count'
  ];
  
  for (const headerName of possibleHeaders) {
    const headerValue = headers.get(headerName);
    if (headerValue) {
      const totalCount = parseInt(headerValue, 10);
      if (!isNaN(totalCount)) {
        return totalCount;
      }
    }
  }
  
  return 0;
};